import { Badge } from "@light-technology/components";
import { differenceInCalendarDays } from "date-fns";
import type { Invoice } from "../../state/api.types";

// Keep in sync with: light-ui/src/components/dash/Billing/InvoiceStatus.tsx

type InvoiceStatusProps = {
  invoice: Invoice;
};

export const InvoiceStatus = (props: InvoiceStatusProps) => {
  const due = differenceInCalendarDays(
    props.invoice.payment_due_date,
    new Date(),
  );
  if (props.invoice.paid_at) {
    return (
      <Badge color="success" size="sm" type="pill-color">
        Paid
      </Badge>
    );
  }
  if (props.invoice.is_deferred && props.invoice.total_cents < 50) {
    return (
      <Badge color="gray" size="sm" type="pill-color">
        Deferred by you
      </Badge>
    );
  }
  if (props.invoice.is_deferred) {
    return (
      <Badge color="gray" size="sm" type="pill-color">
        Deferred by customer
      </Badge>
    );
  }
  if (props.invoice.rebill_invoice) {
    return (
      <Badge color="gray" size="sm" type="pill-color">
        Cancelled for correction
      </Badge>
    );
  }
  if (due < 0) {
    return (
      <Badge color="error" size="sm" type="pill-color">
        Past due
      </Badge>
    );
  }
  if (due === 0) {
    return (
      <Badge color="warning" size="sm" type="pill-color">
        Autopay today
      </Badge>
    );
  }
  return (
    <Badge color="warning" size="sm" type="pill-color">
      Autopay in {due} {due === 1 ? "day" : "days"}
    </Badge>
  );
};
